import { render, staticRenderFns } from "./TransactionExpired.vue?vue&type=template&id=60e06252"
import script from "./TransactionExpired.vue?vue&type=script&lang=js"
export * from "./TransactionExpired.vue?vue&type=script&lang=js"
import style0 from "./TransactionExpired.vue?vue&type=style&index=0&id=60e06252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports